<template>
  <div class="home main">
    <!-- 轮播图部分 -->
    <div class="carousel">
      <a-carousel arrows autoplay>
        <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <div>
          <img src="../../assets/imgs/banner1.png" />
        </div>
        <div>
          <img src="../../assets/imgs/banner2.png" />
        </div>
        <div>
          <img src="../../assets/imgs/banner3.png" />
        </div>
      </a-carousel>
    </div>
    <!-- 优惠产品 -->
    <discount-box></discount-box>
    <!-- 流程 -->
    <!-- <process/> -->
    <!-- 热销产品 -->
    <div class="hot-div mt20">
      <hot-box title="近期热卖商品" :hotList="hotList" :isFlex="isFlex"></hot-box>
      <hot-box :hotList="hotList" :isFlex="isFlex"></hot-box>
    </div>
  </div>
</template>

<script>
import hotBox from '@/components/hotBox.vue'
import discountBox from '@/components/discountBox.vue'
// import process from './components/process'
import { getRd } from '@/serve/home'
import { shopSkusList } from '@/serve/shop'
import { mapState } from 'vuex'
export default {
  name: 'home',
  components: {
    discountBox,
    hotBox
    // process
  },
  computed: {
    ...mapState({
      loginType: state => state.user.loginType,
      ageStage: state => state.user.ageStage,
      blocTagBlocId: state => state.user.blocTagBlocId
    })
  },
  data () {
    return {
      hotList: [], // 热卖产品
      hotList1: [],
      isFlex: true
    }
  },
  methods: {
    init () {
      let tempName = []
      getRd({ page: 0, shoperType: this.loginType, ageStage: this.ageStage, blocTagBlocId: this.blocTagBlocId }).then(res => {
        let skus = res.join(',')
        shopSkusList({ skus }).then(data => {
          for (let i = 0; i < data.length; i++) {
            if (tempName.indexOf(data[i].productId) === -1) {
              tempName.push(data[i].productId)
              if (this.hotList.length < 4) {
                this.hotList.push(data[i])
              }
            }
          }
          /* if (this.hotList.length < 3) {
              this.isFlex = false
            } else if (this.hotList.length > 3) {
              this.isFlex = true
            } */
        })
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
.home {
  .carousel {
    // margin-left: 270px;
    // height: 634px;
    height: 492px;
    overflow-y: hidden;

    img {
      // width: 920px;
      // width: 1190px;
      // height: 316px;
      width: 100%;
      height: 492px;
    }
    .ant-carousel .slick-slide {
      text-align: center;
      height: 160px;
      line-height: 160px;
      background: #364d79;
      overflow: hidden;
    }

    .ant-carousel .custom-slick-arrow {
      width: 25px;
      height: 25px;
      font-size: 25px;
      color: #fff;
      background-color: rgba(31, 45, 61, 0.11);
      opacity: 0.3;
    }
    .ant-carousel .custom-slick-arrow:before {
      display: none;
    }
    .ant-carousel .custom-slick-arrow:hover {
      opacity: 0.5;
    }
  }
  .hot-div {
    display: flex;
    justify-content: space-between;
  }
}
</style>
